import _ from "@lodash";
import { IconButton, Tooltip, Typography, withStyles } from "@material-ui/core";
import XAPPTooltip from "app/Core/Components/Tooltip/XAPPTooltip";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import React from "react";
import { MdDone, MdOutlinePreview } from "react-icons/md";
import { RiDownloadCloudFill } from "react-icons/ri";
import Constante from 'Constante.json';
import { VscClearAll } from "react-icons/vsc";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "../Arquivo/Store/Actions/ArquivoActions";
import GaleriaDialog from "./GaleriaDialog";
import { FuseAnimate } from "@fuse";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    classIcon: {
        padding: "6px",
        position: "absolute",
        top: 0,
        right: 0,
        opacity: 1
    },
    classImage: {
        transitionProperty: "box-shadow",
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        boxShadow: theme.shadows[5],
        opacity: 1,
        backgroundColor: "#fff"
    }
});

class GaleriaList extends XAPPComponent {

    state = {
        open: null
    };

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    };

    filterArquivos = () => {
        var array = [];
        const { arquivoState, Galeria } = this.props;
        if (!_.isUndefined(Galeria.data) && !_.isNull(Galeria.data)) {
            Galeria.data.forEach(item => {
                var BPastaSel = true;
                var BTagSel = true;

                if (item.pasta !== arquivoState.pasta) {
                    BPastaSel = false;
                }

                if (BPastaSel && this.props.conditions && this.props.conditions !== null) {
                    const { tag } = this.props.conditions;
                    if (tag && tag !== null && tag.length > 0) {
                        BTagSel = false;
                        tag.split(",").forEach((itemtag) => {
                            if (item.tags !== null && item.tags.split(",").includes(itemtag)) {
                                BTagSel = true;
                            }
                            else {
                                BTagSel = false;
                            }
                        });
                    }
                }

                if (BPastaSel && BTagSel) {
                    array.push(item);
                }
            });
        }

        return array;
    };

    getIconImage = (_AItem) => {
        const { classes, setSelected, getImage, xappRouteParams, selected } = this.props;
        if (selected !== null && _.findIndex(selected, { idarquivo: _AItem.idarquivo }) >= 0) {
            return (
                <IconButton
                    onClick={() => setSelected(_AItem.idarquivo)}
                    className={classNames(classes.classIcon, "text-green bg-white hover:bg-white")}
                >
                    <MdDone />
                </IconButton>
            );
        }
        else if (!_.isUndefined(_AItem.base64) && !_.isNull(_AItem.base64)) {
            return (
                <IconButton
                    onClick={() => setSelected(_AItem.idarquivo)}
                    className={classNames(classes.classIcon, "text-grey-dark bg-white hover:bg-white")}
                >
                    <MdDone />
                </IconButton>
            );
        }
        else if (_AItem.downloading) {
            return (
                <IconButton
                    onClick={() => { }}
                    className={classNames(classes.classIcon, "text-blue bg-white hover:bg-white")}
                >
                    <RiDownloadCloudFill />
                </IconButton>
            );
        }
        else {
            return (
                <IconButton
                    onClick={() => {
                        getImage(_AItem.idarquivo, xappRouteParams, "0");
                    }}
                    className={classNames(classes.classIcon, "text-grey-dark bg-white hover:bg-white")}
                >
                    <RiDownloadCloudFill />
                </IconButton>
            );
        }
    };

    render() {
        const { xappRouteParams, classes, setSelected, selected } = this.props;
        const { open } = this.state;
        const data = this.filterArquivos();
        return (
            <React.Fragment>
                <GaleriaDialog
                    open={open}
                    openDialog={this.openDialog}
                    xappRouteParams={xappRouteParams}
                />
                <div className="flex w-full">
                    {selected !== null && selected.length > 0 &&
                        <Tooltip
                            title="Visualizar"
                        >
                            <IconButton
                                key="iconBtnShowVisualizacao"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog(true)}
                            >
                                <MdOutlinePreview className={"text-24"} />
                            </IconButton>
                        </Tooltip>
                    }
                    {selected !== null && selected.length > 0 &&
                        <Tooltip
                            title="Limpar seleção"
                        >
                            <IconButton
                                key="iconBtnClearSelected"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => setSelected(null)}
                            >
                                <VscClearAll className={"text-24"} />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
                <div className="flex justify-center sm:justify-start flex-wrap p-16">
                    {data.length > 0 ?
                        <React.Fragment>
                            {data.map(item => (
                                <XAPPTooltip
                                    key={item.idarquivo}
                                    placement="top"
                                    title={
                                        <React.Fragment>
                                            {item.nome} <br /> {item.descricao} <br />
                                        </React.Fragment>
                                    }
                                >
                                    <div className="ml-8 mb-8">
                                        <div
                                            className={classNames(classes.classImage, "flex items-center justify-center relative w-128 h-128 rounded-4 overflow-hidden cursor-pointer")}
                                            key={item.idarquivo}
                                        >
                                            {this.getIconImage(item)}
                                            <div
                                                className="max-w-none w-auto h-full"
                                                style={{
                                                    backgroundImage: "url(data:" + (item.thumbnail ? item.thumbnail : Constante.default_image) + ")",
                                                    backgroundRepeat: "no-repeat, repeat",
                                                    height: "128px",
                                                    width: "128px",
                                                    backgroundSize: "128px 128px",
                                                    backgroundPosition: "center",
                                                    cursor: "pointer"
                                                }}
                                                alt={item.nome}
                                            />
                                        </div>
                                        <p>{item.descricao.substring(0, 18)}</p>
                                    </div>
                                </XAPPTooltip>
                            ))}
                        </React.Fragment>
                        :
                        <div className="flex flex-col flex-1 items-center justify-center p-48">
                            <div className="max-w-512 text-center">
                                <FuseAnimate delay={500}>
                                    <Typography variant="h6" color="textSecondary" className="mb-16">
                                        {"Não existem registros cadastrados!"}
                                    </Typography>
                                </FuseAnimate>
                            </div>
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getImage: Actions.getImage,
        setSelected: Actions.setSelected,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        Galeria: Arquivo,
        selected: Arquivo.selected,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GaleriaList)));
